// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_daily__pTrGP {
  margin: 16px 0;
  background: rgb(117, 83, 240);
  border-radius: 20px;
  overflow: hidden;
}
.style_daily__divider__y\\+I-A {
  height: 1px;
  width: 100%;
  background: rgb(255, 255, 255);
  opacity: 0.1;
  margin: 0 16px;
}
.style_daily__head__iHsq1 {
  display: flex;
  padding-bottom: 12px;
  padding: 16px 16px;
}
.style_daily__head__part__REnwI {
  display: flex;
  gap: 12px;
  flex: 2 1;
}
.style_daily__head__button__y6Wwp {
  flex: 1 1;
  position: relative;
}
.style_daily__head__icon__T2YAK {
  font-size: 3.4rem;
}
.style_daily__head__content__myrlR {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
}
.style_daily__head__content__myrlR h3 {
  font-size: 1.8rem;
  color: rgb(255, 255, 255);
  font-weight: 600;
}
.style_daily__head__content__myrlR p {
  font-size: 1.2rem;
  color: rgb(255, 255, 255);
  font-weight: 600;
}
.style_daily__head__sunshine__lpSj8 {
  position: absolute;
  width: 200px;
  height: 200px;
  z-index: 1;
  opacity: 0.3;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.style_daily__head__sunshine__lpSj8 img {
  width: 100%;
  height: 100%;
  animation: style_rotate__ZrwZB 20s linear infinite;
}
.style_daily__head__action__x4j3n {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.style_daily__head__timer__SlKSR {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
}
.style_daily__requirements__qg7hq {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
}
.style_daily__requirements__title__d4L5C {
  font-size: 1.2rem;
  font-weight: 700;
  color: rgb(247, 246, 255);
}
.style_daily__requirements__time__Qn4tJ {
  font-size: 1.2rem;
  font-weight: 500;
  display: flex;
  gap: 6px;
  justify-content: center;
  color: rgb(247, 246, 255);
}
.style_daily__tasks__Hf7Sc {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  padding: 12px 16px;
}
.style_daily__description__6MofP {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
}
.style_daily__description__text__RmxHU {
  color: rgb(255, 255, 255);
  font-size: 1.2rem;
  font-weight: 500;
}

@keyframes style_rotate__ZrwZB {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/earn/tasks/%D1%81uberium-daily-streak/style.module.scss","webpack://./public/assets/colors.scss","webpack://./src/pages/earn/tasks/сuberium-daily-streak/style.module.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,6BCJK;EDKL,mBAAA;EACA,gBAAA;AEDF;AFEE;EACE,WAAA;EACA,WAAA;EACA,8BCLI;EDMJ,YAAA;EACA,cAAA;AEAJ;AFEE;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;AEAJ;AFEI;EACE,aAAA;EACA,SAAA;EACA,SAAA;AEAN;AFGI;EACE,SAAA;EACA,kBAAA;AEDN;AFII;EACE,iBAAA;AEFN;AFII;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AEFN;AFGM;EACE,iBAAA;EACA,yBCnCA;EDoCA,gBAAA;AEDR;AFGM;EACE,iBAAA;EACA,yBCxCA;EDyCA,gBAAA;AEDR;AFKI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EAEA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AEJN;AFKM;EACE,WAAA;EACA,YAAA;EACA,kDAAA;AEHR;AFOI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AELN;AFOI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AELN;AFSE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AEPJ;AFQI;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AENN;AFSI;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,yBAAA;AEPN;AFWE;EACE,aAAA;EACA,kCAAA;EACA,SAAA;EACA,kBAAA;AETJ;AFYE;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AEVJ;AFWI;EACE,yBChHE;EDiHF,iBAAA;EACA,gBAAA;AETN;;AFcA;EACE;IACE,uBAAA;EEXF;EFaA;IACE,yBAAA;EEXF;AACF","sourcesContent":["@import 'public/assets/colors';\n\n.daily {\n  margin: 16px 0;\n  background: $main;\n  border-radius: 20px;\n  overflow: hidden;\n  &__divider {\n    height: 1px;\n    width: 100%;\n    background: $white;\n    opacity: 0.1;\n    margin: 0 16px;\n  }\n  &__head {\n    display: flex;\n    padding-bottom: 12px;\n    padding: 16px 16px;\n\n    &__part {\n      display: flex;\n      gap: 12px;\n      flex: 2;\n    }\n\n    &__button {\n      flex: 1;\n      position: relative;\n    }\n\n    &__icon {\n      font-size: 3.4rem;\n    }\n    &__content {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n      align-items: flex-start;\n      h3 {\n        font-size: 1.8rem;\n        color: $white;\n        font-weight: 600;\n      }\n      p {\n        font-size: 1.2rem;\n        color: $white;\n        font-weight: 600;\n      }\n    }\n\n    &__sunshine {\n      position: absolute;\n      width: 200px;\n      height: 200px;\n      z-index: 1;\n      // overflow: hidden;\n      opacity: 0.3;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      img {\n        width: 100%;\n        height: 100%;\n        animation: rotate 20s linear infinite;\n      }\n    }\n\n    &__action {\n      position: absolute;\n      z-index: 2;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n    &__timer {\n      display: flex;\n      justify-content: flex-end;\n      padding-right: 10px;\n    }\n  }\n\n  &__requirements {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 2px;\n    &__title {\n      font-size: 1.2rem;\n      font-weight: 700;\n      color: rgba(247, 246, 255, 1);\n    }\n\n    &__time {\n      font-size: 1.2rem;\n      font-weight: 500;\n      display: flex;\n      gap: 6px;\n      justify-content: center;\n      color: rgba(247, 246, 255, 1);\n    }\n  }\n\n  &__tasks {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 10px;\n    padding: 12px 16px;\n  }\n\n  &__description {\n    margin-bottom: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    align-items: center;\n    &__text {\n      color: $white;\n      font-size: 1.2rem;\n      font-weight: 500;\n    }\n  }\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n",".daily {\n  margin: 16px 0;\n  background: rgb(117, 83, 240);\n  border-radius: 20px;\n  overflow: hidden;\n}\n.daily__divider {\n  height: 1px;\n  width: 100%;\n  background: rgb(255, 255, 255);\n  opacity: 0.1;\n  margin: 0 16px;\n}\n.daily__head {\n  display: flex;\n  padding-bottom: 12px;\n  padding: 16px 16px;\n}\n.daily__head__part {\n  display: flex;\n  gap: 12px;\n  flex: 2;\n}\n.daily__head__button {\n  flex: 1;\n  position: relative;\n}\n.daily__head__icon {\n  font-size: 3.4rem;\n}\n.daily__head__content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: flex-start;\n}\n.daily__head__content h3 {\n  font-size: 1.8rem;\n  color: rgb(255, 255, 255);\n  font-weight: 600;\n}\n.daily__head__content p {\n  font-size: 1.2rem;\n  color: rgb(255, 255, 255);\n  font-weight: 600;\n}\n.daily__head__sunshine {\n  position: absolute;\n  width: 200px;\n  height: 200px;\n  z-index: 1;\n  opacity: 0.3;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.daily__head__sunshine img {\n  width: 100%;\n  height: 100%;\n  animation: rotate 20s linear infinite;\n}\n.daily__head__action {\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.daily__head__timer {\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 10px;\n}\n.daily__requirements {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n}\n.daily__requirements__title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: rgb(247, 246, 255);\n}\n.daily__requirements__time {\n  font-size: 1.2rem;\n  font-weight: 500;\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n  color: rgb(247, 246, 255);\n}\n.daily__tasks {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 10px;\n  padding: 12px 16px;\n}\n.daily__description {\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: center;\n}\n.daily__description__text {\n  color: rgb(255, 255, 255);\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"daily": `style_daily__pTrGP`,
	"daily__divider": `style_daily__divider__y+I-A`,
	"daily__head": `style_daily__head__iHsq1`,
	"daily__head__part": `style_daily__head__part__REnwI`,
	"daily__head__button": `style_daily__head__button__y6Wwp`,
	"daily__head__icon": `style_daily__head__icon__T2YAK`,
	"daily__head__content": `style_daily__head__content__myrlR`,
	"daily__head__sunshine": `style_daily__head__sunshine__lpSj8`,
	"rotate": `style_rotate__ZrwZB`,
	"daily__head__action": `style_daily__head__action__x4j3n`,
	"daily__head__timer": `style_daily__head__timer__SlKSR`,
	"daily__requirements": `style_daily__requirements__qg7hq`,
	"daily__requirements__title": `style_daily__requirements__title__d4L5C`,
	"daily__requirements__time": `style_daily__requirements__time__Qn4tJ`,
	"daily__tasks": `style_daily__tasks__Hf7Sc`,
	"daily__description": `style_daily__description__6MofP`,
	"daily__description__text": `style_daily__description__text__RmxHU`
};
export default ___CSS_LOADER_EXPORT___;
